module.exports = __webpack_public_path__ + "images/a8d6a6953f40a6bfe2c7572aa61b4e6a.jpg";